import { render, staticRenderFns } from "./SpotlightGuide.vue?vue&type=template&id=8b29a57a&scoped=true"
import script from "./SpotlightGuide.vue?vue&type=script&lang=js"
export * from "./SpotlightGuide.vue?vue&type=script&lang=js"
import style0 from "./SpotlightGuide.vue?vue&type=style&index=0&id=8b29a57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b29a57a",
  null
  
)

export default component.exports